<template>
  <div class="not_found">
    <transition name="fade">
      <div class="popup top_flow">
        <div class="holder">
          <h3>Please select a kiosk below</h3>
          <div class="kiosks">
            <div v-for="k in kiosks" :key="k.id" class="kiosk" @click="startKiosk(k)">
              <div>
                <p>{{k.name}}</p>
                <p>{{k.description}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script type="text/javascript">
import { db } from "@/config/firebaseInit.js";

export default {
  props: ["link"],
  data() {
    return {
      btnActive: true,
      kiosks: null
    };
  },
  methods: {
    startKiosk(k) {
      this.$router.push({ path: "/home/" + k.id });
    }
  },
  created() {
    db.collection("kiosks").onSnapshot(
      { includeMetadataChanges: true },
      snapshot => {
        let vm = this;
        snapshot.docChanges().forEach(function(change) {
          if (change.type === "modified") {
            let defaulted = change.doc.data().default;
            if (defaulted) {
              vm.$router.push({ path: "/home/" + change.doc.id });
            }
          }
        });

        this.kiosks = snapshot.docs.map(d =>
          Object.assign({ id: d.id }, d.data())
        );
      }
    );
  }
};
</script>

<style>
h3 {
  font-family: Georgia;
  font-size: 55px;
  font-weight: 100;
}
.inactive {
  pointer-events: none;
}

.holder {
  padding-bottom: 0 !important;
  text-align: center;
}

.loader {
  width: 100%;
  text-align: center;
}

.loader img {
  height: 100px;
  opacity: 0;
  transition: opacity 0.3s;
}

.loader.active img {
  opacity: 1;
}

.not_found .popup {
  background-color: #ffffff;
}

.popup.top_flow {
  align-items: flex-start;
}

.popup.top_flow .holder {
  width: 100%;
  padding-top: 100px;
  background-color: transparent;
}

.kiosks {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  margin-top: 50px;
  width: 100%;
}

.kiosks .kiosk {
  background-color: #f09168;
  box-shadow: 0px 0px 7px #80808033;
  padding: 45px 30px;
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  box-sizing: border-box;
}

.kiosks .kiosk p {
  margin: 0;
  font-size: 40px !important;
  font-family: Georgia !important;
  font-weight: 100 !important;
  color: #ffffff;
}
.kiosks .kiosk p:first-child {
  font-weight: 900;
  margin-bottom: 0;
  font-size: 27px;
  text-transform: uppercase;
  font-family: "azo-sans-web", sans-serif;
}

.kiosks .kiosk .arr {
  height: 30px;
  filter: brightness(0.9);
}
</style>